import { render, staticRenderFns } from "./adminCategory.vue?vue&type=template&id=b436d0ea&scoped=true"
import script from "./adminCategory.vue?vue&type=script&lang=js"
export * from "./adminCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b436d0ea",
  null
  
)

export default component.exports